import { useEffect, useState } from "react";
import { TIME } from "./common/utils";
import Modal from "./common/Modal";
import "./Breathe.scss";

const MILLISECONDS = 3200,
  SECONDS = 12;

const Breathe = ({ feature, onDone }) => {
  const [inhale, setInhale] = useState(true),
    [modal, setModal] = useState(true),
    [modalType, setModalType] = useState("START"),
    [seconds, setSeconds] = useState(SECONDS);
  useEffect(() => {
    setInhale(true);
    setModal(true);
    setModalType("START");
    setSeconds(SECONDS);
  }, []);
  useEffect(() => {
    let toggle = setInterval(() => setInhale(!inhale), MILLISECONDS);
    return () => clearInterval(toggle);
  }, [inhale]);
  useEffect(() => {
    if (!modal) {
      let cancel = false;
      let timeout = TIME(seconds, setSeconds, cancel, true, () => onDone());
      return () => {
        clearTimeout(timeout);
        cancel = true;
      };
    }
  }, [modal, onDone, seconds]);
  return (
    <>
      <Modal
        feature={feature}
        show={modal}
        type={modalType}
        kind={"BREATHE"}
        heading={"Breathing exercise"}
        intro={`Helps bring your mind to the present by focusing on your breath.`}
        done={() => {
          if (modalType === "START") {
            setModal(false);
            setModalType("");
          }
        }}
      />
      <div className="game-breathe">
        <div className="emotion-text">
          {`Breathing Exercise : ${seconds} Sec`}
        </div>
        <svg width="100%" height="100%">
          <defs>
            <linearGradient id="gradient">
              <stop offset="0%" stopColor="#348f50" />
              <stop offset="100%" stopColor="#56b4d3" />
            </linearGradient>
          </defs>
          <circle
            style={{
              transform: `scale(${!modal && seconds ? 1 : 0.75})`,
              transformOrigin: "center",
              animation:
                !modal && seconds
                  ? `pulse ${(MILLISECONDS * 2) / 1000}s infinite`
                  : ""
            }}
            cx="50%"
            cy="50%"
            r="20%"
            fill="url(#gradient)"
          />
          <text
            className="game-breathe-text"
            x="50%"
            y="50%"
            textAnchor="middle"
            stroke="#000000"
            strokeWidth="2px"
            dy=".3em"
          >
            {`${inhale ? "in" : "ex"}hale`}
          </text>
        </svg>
      </div>
    </>
  );
};

export default Breathe;
